import { normalizeError } from '@mx/pay-common';
import {
  bridge,
  CallbackPayResultSource,
  env,
  getStorage,
  monitor,
  PAY_RESULT_FOR_DEFER,
  removeStorage,
  showOpenStatusPage,
} from '@/common';
import { storeInstance } from '@/store';

const store = storeInstance();
/**
 * 展示支付后结果页面（支付SDK<9.8.0 支付成功或者独立签约成功）
 * 由于此处会回调业务方，所以调用此方法时需要注意保证已经签约成功
 * @param promotion
 */
export function showResultPage(promotion: any, callbackResult: (param: string) => void) {
  console.log('promotion::', promotion);
  if (!promotion || (typeof promotion === 'object' && Object.keys(promotion).length <= 0)) {
    // 此处为了保证线路闭环，不展示半页弹窗，直接回调业务线
    callbackResult(CallbackPayResultSource.nonShowCouponDialog);
    return;
  }
  // 此处没有增加版本控制，因为先用后付上线时支付后弹窗桥已经可用
  bridge
    .notifyNative('pay.showCouponDialog', {
      promotion,
      tradeNo: env.inpayBasicBusinessParams.tradeno || '',
    })
    .then(() => {
      // Android、iOS 都走此逻辑，iOS 虽然执行了此代码，但是可能由于时序问题，无法关闭签约页面，通过下方 appear 订阅进行兜底
      callbackResult(CallbackPayResultSource.bridgeCouponDialogSuccess);
    })
    .catch((error: any) => {
      callbackResult(CallbackPayResultSource.bridgeCouponDialogFail);
      monitor.captureJSErrorMessage('[bridge]唤起结果页失败', { error: normalizeError(error) });
    });

  // iOS 由于时序问题，不确定是否触发 'pay.showCouponDialog' 中 success 回调，此处多处理一次，经沟通是否有额外异常，通过日志上报排查是否是触发两次
  // getStorage 有千分之三的失败率，所以安卓不采用此方式
  if (env.isIOS) {
    bridge.subscribe({
      action: 'appear',
      handle: () => {
        getStorage(PAY_RESULT_FOR_DEFER)
          .then((data: any) => {
            if (data === '1') {
              callbackResult(CallbackPayResultSource.appearCouponDialog);
            }
          })
          .catch((error: any) => {
            monitor.captureJSErrorMessage('[bridge]iOS getStorage 订阅失败', { error: normalizeError(error) });
          })
          .finally(() => {
            removeStorage(PAY_RESULT_FOR_DEFER);
          });
      },
    });
  }
}
// 独立场景签约成功结果页/先用后付已签约说明页
export function showPayDelaySignResultPage(failCallBack: Function = () => {}): Promise<void> {
  return new Promise((resolve, reject) => {
    showOpenStatusPage({
      scorePlanId: env.scorePlanIdFromUrl,
      openType: 1,
      creditType: env.creditType,
    })
      .then((res) => {
        store.commit({ type: 'result/setResultData', resultData: res.showData });
        store.commit({ type: 'result/setShowResult', showResult: true });
        resolve();
      })
      .finally(() => {
        store.commit({ type: 'paydelaycashier/setShowHalfPage', showHalfPage: true });
      })
      .catch((error) => {
        monitor.captureAjaxErrorMessage('[api]先用后付（原安心付）签约结果接口请求异常', {
          normalizeError: normalizeError(error),
        });
        failCallBack(error);
        reject();
      });
  });
}
